import { render } from "./RocketIcon.vue?vue&type=template&id=399fa950"
const script = {}
script.render = render

export default script